import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RuleManage = _resolveComponent("RuleManage")!
  const _component_SaleCue = _resolveComponent("SaleCue")!
  const _component_CosFullLayout = _resolveComponent("CosFullLayout")!

  return (_openBlock(), _createBlock(_component_CosFullLayout, null, {
    aside: _withCtx(() => [
      _createVNode(_component_RuleManage, {
        listData: _ctx.listData,
        onSelectTag: _ctx.selectTag
      }, null, 8, ["listData", "onSelectTag"])
    ]),
    main: _withCtx(() => [
      _createVNode(_component_SaleCue, { data: _ctx.selectTagName }, null, 8, ["data"])
    ]),
    _: 1
  }))
}